<section id="alertas">
    <div class="contenedor__alertas">
        <div *ngFor="let alerta of alertService.alertas" class="alert alert-{{ alerta.tipo }}" role="alert">
            {{ alerta.mensaje | translate }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    </div>
</section>